import React, { useState, useEffect } from 'react';
import { useStaticQuery, graphql, navigate } from 'gatsby';
import * as styles from './navigation.module.scss';
import FertilityTestCta from './fertility-test-cta';
import CartIcon from './cart-icon';
import { ChevronDown, ChevronUp } from 'lucide-react';
import Link from '../utils/link';

export default function Navigation() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [openSubMenus, setOpenSubMenus] = useState({});

  const toggleMenu = () => setMenuOpen((prev) => !prev);

  const toggleSubMenu = (index) => setOpenSubMenus((prev) => ({ ...prev, [index]: !prev[index] }));

  const handleLinkClick = (link) => {
    if (window.location.pathname === link) {
      setMenuOpen(false);
    } else {
      navigate(link);
    }
  };

  const data = useStaticQuery(graphql`
    query MyQuery {
      allStaticNavbarYaml {
        nodes {
          caret {
            desktop {
              img {
                publicURL
              }
              img_red {
                publicURL
              }
              alt
            }
          }
          navbar {
            color
            link
            text
            img {
              publicURL
            }
            alt
            items {
              color
              link
              text
              img {
                publicURL
              }
              extern
              alt
            }
          }
          logo {
            alt
            img {
              publicURL
            }
          }
          account {
            img {
              publicURL
            }
            alt
          }
          mobileMenu {
            alt
            img {
              publicURL
            }
          }
          closemobileMenu {
            alt
            img {
              publicURL
            }
          }
        }
      }
    }
  `);

  useEffect(() => {
    document.body.classList.toggle('no-scroll', menuOpen);
    return () => document.body.classList.remove('no-scroll');
  }, [menuOpen]);

  return (
    <>
      <div className={styles.header}>
        <div className={styles.container}>
          <Link to="/">
            <img
              src={data.allStaticNavbarYaml.nodes[0].logo.img.publicURL}
              alt={data.allStaticNavbarYaml.nodes[0].logo.alt}
              style={{ maxWidth: '75%', padding: '0px 20px' }}
            />
          </Link>
          <div className={styles.flex}>
            <nav>
              <ul className={styles.pages}>
                {data.allStaticNavbarYaml.nodes[0].navbar.map((item, index) => (
                  <li
                    key={index}
                    className={styles.page}
                    onMouseEnter={() => setOpenDropdown(index)}
                    onMouseLeave={() => setOpenDropdown(null)}
                  >
                    {item.img ? (
                      <a href="https://my.bemum.co" target="_blank">
                        <img src={item.img.publicURL} alt={item.alt} />
                      </a>
                    ) : item.link ? (
                      <Link to={item.link}>{item.text}</Link>
                    ) : (
                      item.text
                    )}

                    {item.items && (
                      <ul className={`${styles.dropdown} ${openDropdown === index ? styles.open : ''}`}>
                        <div className={styles.dropdownInner}>
                          {item.items.map((subItem, subIndex) => (
                            <li key={subIndex} className={styles.dropdownLi}>
                              <Link to={subItem.link}>{subItem.text}</Link>
                            </li>
                          ))}
                        </div>
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </nav>

            <CartIcon />
            <FertilityTestCta label="Test fertilité" />
          </div>
        </div>

        {/* Mobile Menu */}
        <div className={styles.containerMobile}>
          <button
            className={`${styles.burger} ${menuOpen ? styles.open : ''}`}
            onClick={toggleMenu}
            aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          >
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
            <span aria-hidden="true"></span>
          </button>
          <Link to="/" onClick={() => setMenuOpen(false)}>
            <img
              src={data.allStaticNavbarYaml.nodes[0].logo.img.publicURL}
              alt={data.allStaticNavbarYaml.nodes[0].logo.alt}
              style={{ maxWidth: '70%', padding: '0px 20px' }}
            />
          </Link>
          <div className={styles.flex}>
            <a href="https://my.bemum.co" className={styles.contentHeight} target="_blank">
              <img
                src={data.allStaticNavbarYaml.nodes[0].account.img.publicURL}
                alt={data.allStaticNavbarYaml.nodes[0].account.alt}
              />
            </a>
            <CartIcon />
          </div>
        </div>
      </div>

      {/* Mobile Menu Content */}
      <div>
        <div className={`${styles.mobileMenu} ${menuOpen ? styles.mobileMenuOpen : ''}`}>
          <ul className={styles.menuList}>
            {data.allStaticNavbarYaml.nodes[0].navbar.map((item, index) => (
              <li key={index} className={styles.menuItem}>
                <div
                  className={styles.menuItemContent}
                  onClick={() => toggleSubMenu(index)}
                  style={{ cursor: 'pointer' }}
                >
                  <a onClick={() => handleLinkClick(item.link)} style={{ fontSize: '18px', fontWeight: '400' }}>
                    {item.text}
                  </a>
                  {item.items && (
                    <button
                      className={`${styles.subMenuButton} ${openSubMenus[index] ? styles.active : ''}`}
                      aria-label={openSubMenus[index] ? 'Fermer le sous menu' : 'Ouvrir le sous menu'}
                    >
                      {openSubMenus[index] ? (
                        <ChevronUp size={25} color={'#000'} />
                      ) : (
                        <ChevronDown size={25} color={'#000'} />
                      )}
                    </button>
                  )}
                </div>
                {item.items && (
                  <ul className={`${styles.subMenu} ${openSubMenus[index] ? styles.subMenuOpen : ''}`}>
                    {item.items.map((subItem, subIndex) => (
                      <li key={subIndex} className={styles.subItemMobile}>
                        <img src={subItem.img.publicURL} alt="" aria-hidden="true" className={styles.subItemIcon} />
                        <a onClick={() => handleLinkClick(subItem.link)} className={styles.linkButton}>
                          {subItem.text}
                        </a>
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            ))}
          </ul>

          <FertilityTestCta label="FAIRE MON TEST DE FERTILITÉ" display="flex" justifyContent="center" />
        </div>
      </div>
    </>
  );
}
